import React, { Component } from 'react';
import ProjectPage from '../../components/ProjectPage';
import Table from '../../components/Table';
import Banner from '../../images/projects/TheShipwreckBanner.jpg'

class TheShipwreck extends Component {
  render() {
    return (
    <ProjectPage title="The Shipwreck" banner={Banner}>

      <div className='project-page-part'>

        <Table className="centered" data = {{
          Status : "Finished",
          Type : "School Project",
          Engine : "Unity",
          Language : "C#",
          Duration : "2 weeks",
          Team : "Group of 4",
          Date : "2023"
        }}/>

      </div>

      <div className='project-page-part'>

        <h3>Context :</h3>
        <p className='basic-text'>
          The objective of the project was to create a VR game in Unity.
        </p>

      </div>

      <div className='project-page-part'>

        <h3>Game :</h3>
        <p className='basic-text'>
          The Shipwreck is an escape game in VR.<br/>
          <br/>
          During a stopover at the tavern "The Shipwreck" to resupply the ship, you, Jean Chois, became the victim of mutiny! In just a few seconds, the entire crew fled towards the ship, locking you inside the tavern, alone. <br/>

          Your objective: escape from the tavern before the dynamite they left with us explodes!
        </p>

      </div>

      <div className='project-page-part'>

        <h3>Gameplay :</h3>

        <iframe className='project-video' title='The Shipwreck demo' allowFullScreen
        src="https://youtube.com/embed/iuyTCG_CnyI">
        </iframe>

      </div>

    </ProjectPage>
    );
  }
}

export default TheShipwreck;